window.get_data = function () {
  if ($("#date_check").is(":checked") && $("#room_check").is(":checked")) {
    date = $("#date_selected").val();
    room = $("#room_selected").val();
    if (date == "") {
      $("#display").text("Debe seleccionar una FECHA");
      $("#reservations").html("");
      return;
    }
    if (room == "") {
      $("#display").text("Debe seleccionar un ESPACIO");
      $("#reservations").html("");
      return;
    }
    $.ajax({
      type: "POST",
      url: "/reservations/get_reservations",
      data: {
        date: date,
        room: room,
        state: 0,
      },
      dataType: "json",
      success: function (data) {
        $("#display").text(data.name);
        var dateFormat = new Date(date + "EDT");
        var displayDate =
          day_to_spanish(dateFormat.getDay()) +
          " " +
          dateFormat.getDate() +
          " de " +
          month_to_spanish(dateFormat.getMonth());
        $("#title_display").text(displayDate);
        if (data.status == 200) {
          var reservations_data = "";
          var data = data.data;
          $.each(data, function (key, value) {
            console.log(value);
            if (key === 0) return;
            reservations_data += '<div class="ei_Dot" ></div>';
            reservations_data += `<div class="ei_Title"> ${value.hour} (${value.status}) </div>`;
            reservations_data += '<div class="ei_Copy">' + " " + "</div>";
          });
          $("#reservations").html(reservations_data);
        } else {
          var reservations_data = data.data[0];
          $("#reservations").html(reservations_data);
        }
      },
    });
  } else if (
    $("#date_check").is(":checked") &&
    !$("#room_check").is(":checked")
  ) {
    date = $("#date_selected").val();
    if (date == "") {
      $("#display").text("Debe seleccionar una FECHA");
      $("#reservations").html("");
      return;
    }
    $.ajax({
      type: "POST",
      url: "/reservations/get_reservations",
      data: {
        date: date,
        state: 1,
      },
      dataType: "json",
      success: function (data) {
        var dateFormat = new Date(date + "EDT");
        var displayDate =
          day_to_spanish(dateFormat.getDay()) +
          " " +
          dateFormat.getDate() +
          " de " +
          month_to_spanish(dateFormat.getMonth());
        $("#display").text(displayDate);
        $("#title_display").text("Fecha Seleccionada");
        if (data.status == 200) {
          var reservations_data = "";
          var data = data.data;
          $.each(data, function (key, value) {
            if (key === 0) return;
            console.log(value);
            reservations_data += '<div class="ei_Dot" ></div>';
            reservations_data += `<div class="ei_Title"> ${value.room} (${value.status}) </div>`;
            reservations_data +=
              '<div class="ei_Copy">' + value.hour + "</div>";
          });
          $("#reservations").html(reservations_data);
        } else {
          var reservations_data = data.data[0];
          $("#reservations").html(reservations_data);
        }
      },
    });
  } else if (
    !$("#date_check").is(":checked") &&
    $("#room_check").is(":checked")
  ) {
    room = $("#room_selected").val();
    if (room == "") {
      $("#display").text("Debe seleccionar un ESPACIO");
      $("#reservations").html("");
      return;
    }
    $.ajax({
      type: "POST",
      url: "/reservations/get_reservations",
      data: {
        room: room,
        state: 2,
      },
      dataType: "json",
      success: function (data) {
        console.log(data);
        $("#display").text(data.name);
        $("#title_display").text("Espacio Seleccionado");

        if (data.status == 200) {
          var reservations_data = "";
          var data = data.data;
          $.each(data, function (key, value) {
            if (key === 0) return;
            console.log(value);
            reservations_data += '<div class="ei_Dot" ></div>';
            reservations_data += `<div class="ei_Title"> ${value.date} (${value.status}) </div>`;
            reservations_data +=
              '<div class="ei_Copy">' + value.hour + "</div>";
          });
          $("#reservations").html(reservations_data);
        } else {
          var reservations_data = data.data[0];
          $("#reservations").html(reservations_data);
        }
      },
    });
  }
};

function day_to_spanish(day) {
  var days = {
    1: "Lunes",
    2: "Martes",
    3: "Miercoles",
    4: "Jueves",
    5: "Viernes",
    6: "Sábado",
    0: "Domingo",
  };
  return days[day];
}

function month_to_spanish(month) {
  var months = {
    0: "Enero",
    1: "Febrero",
    2: "Marzo",
    3: "Abril",
    4: "Mayo",
    5: "Junio",
    6: "Julio",
    7: "Agosto",
    8: "Septiembre",
    9: "Octubre",
    10: "Noviembre",
    11: "Diciembre",
  };
  return months[month];
}

window.activate_date = function () {
  if ($("#date_check").is(":checked")) {
    $("#date_selected").prop("disabled", "");
  } else {
    $("#date_selected").prop("disabled", "disabled");
  }
};
window.activate_room = function () {
  if ($("#room_check").is(":checked")) {
    $("#room_selected").prop("disabled", "");
    $("#to-reservation").prop("hidden", "");
  } else {
    $("#room_selected").prop("disabled", "disabled");
    $("#to-reservation").prop("hidden", "hidden");
  }
};

window.link_button = function (value) {
  $("#to-reservation").attr("href", `/rooms/${value.value}`);
};

window.query_repeat = function () {
  var start = $("#start-repeat").val().replace(/-/g, "/"),
    end = $("#end-repeat").val().replace(/-/g, "/"),
    day = $("#day-repeat").val(),
    block = $("#block-repeat").val(),
    step = $("#step-repeat").val(),
    room = $("#room_id").val();

  dates = window.getDaysBetweenDates(start, end, day, step);
  $.ajax({
    type: "POST",
    url: "/reservations/check_repeat",
    data: {
      room: room,
      start: start,
      end: end,
      day: day,
      block: block,
      step: step,
      dates: dates,
    },
    dataType: "json",
    success: function (data) {
      var _dates = "";
      $("#title-response").text(data.message);
      data.dates.forEach((element) => {
        _dates += `<li>${element}</li>`;
      });
      $("#content-response").html(_dates);
    },
  });
};

window.update_dates_repeat = function () {
  if ($("#repeat-reservation").is(":checked")) {
    var start = $("#start-repeat").val().replace(/-/g, "/"),
      end = $("#end-repeat").val().replace(/-/g, "/"),
      day = $("#day-repeat").val(),
      step = $("#step-repeat").val();
    $("#dates_repeat").val(window.getDaysBetweenDates(start, end, day, step));
  }
};

window.getDaysBetweenDates = function (start, end, day, step) {
  var start_date = new Date(start);
  var end_date = new Date(end);
  if (start_date.getDay() != end_date.getDay()) {
    var endfix = end_date.getDay() == 0 ? 7 : end_date.getDay();
    var diff = start_date.getDay() - endfix;
    end_date.setDate(end_date.getDate() + diff);
  }
  var result = [];
  var current = new Date(start_date);
  current.setDate(
    current.getDate() + ((day - current.getDay() + 7 * step) % 7)
  );
  while (current <= end_date) {
    result.push(new Date(+current));
    current.setDate(current.getDate() + 7 * step);
  }
  return result;
};
